import script from "./ProfileSpouseRelationshipModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSpouseRelationshipModal.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileSpouseRelationshipModal.vue?vue&type=style&index=0&id=63b8c8c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b8c8c2"]])

export default __exports__